import { render, staticRenderFns } from "./TopicMessage.vue?vue&type=template&id=3f4c0b5a&scoped=true"
import script from "./TopicMessage.vue?vue&type=script&lang=js"
export * from "./TopicMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c0b5a",
  null
  
)

export default component.exports